var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.207 33.207"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Search Icon",
    d: "M2 12.5A10.5 10.5 0 1112.5 23 10.5 10.5 0 012 12.5zM12.5 0A12.5 12.5 0 1025 12.5 12.5 12.5 0 0012.5 0zm10.543 24.457l8.75 8.75 1.414-1.414-8.75-8.75z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "4b5897b1b110043a68a91a139d695275.svg";
export { SvgSearchIcon as ReactComponent };